import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[highlight]'
})
export class HighlightDirective implements OnChanges {
  @Input('highlight') highlight: string;
  @Input('text') text: string;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnChanges(changes: SimpleChanges) {
    this.highlightText();
  }

  private highlightText() {
    if (this.highlight) {
      const regex = new RegExp(this.escapeRegex(this.highlight), 'gi');
      const highlightedText = this.text.replace(regex, match => `<span class="highlight">${match}</span>`);
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', highlightedText);
    }
    else {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.text);
    }
  }

  private escapeRegex(text: string): string {
    return !text ? text : text.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
}
